/**
 * Service Worker 업데이트 감지 및 자동 적용
 *
 * 새 SW가 활성화되면 페이지를 자동 reload하여 최신 번들을 사용하도록 한다.
 * - controllerchange: 새 SW가 클라이언트를 제어하기 시작할 때 reload
 * - SW 등록 후 주기적으로 업데이트 체크 (1시간 간격)
 */
export function listenForSwUpdate() {
  if (!("serviceWorker" in navigator)) return;

  // 최초 설치 시에는 reload 불필요 (기존 SW가 없는 경우)
  if (!navigator.serviceWorker.controller) return;

  // 새 SW가 컨트롤러로 전환되면 reload
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  // 주기적 업데이트 체크 (1시간)
  navigator.serviceWorker.ready.then((registration) => {
    setInterval(
      () => {
        registration.update().catch(() => {});
      },
      60 * 60 * 1000,
    );
  });
}
